// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"z3-z"};